import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Stepper from 'react-stepper-horizontal';

import * as setupActions from '@/actions/setupActions';
import {consoleError} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import './Wizard.less';

/**
 * @enum {string}
 */
const Direction = {
  Next: 'Next',
  Previous: 'Previous',
};

/**
 * @enum {string}
 */
const PubsubEvent = {
  DIRECTION: 'Wizard_Direction',
};

@connect((store) => ({
  nextActionWizard: store.setupStore.nextActionWizard,
  prevActionWizard: store.setupStore.prevActionWizard,
}))
class Wizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
    };
    this._bus = eventBusObject();
    this.subscriptionDirection = this._bus.subscribe(PubsubEvent.DIRECTION, (arg) => this.actionEvent(arg));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.nextAction(nextProps);
    this.prevAction(nextProps);
  }

  componentWillUnmount() {
    this.subscriptionDirection.unsubscribe();
  }

  actionEvent = (param) => {
    switch (param) {
      case Direction.Next:
        this.nextActionEvent();
        break;
      case Direction.Previous:
        this.prevActionEvent();
        break;

      default:
        consoleError('Invalid Direction. ');
        break;
    }
  };

  nextActionEvent = () => {
    const {nextActionCallback, step} = this.props;
    const {activeStep} = this.state;

    if (activeStep < step.length - 1) {
      this.setState(
        (prevState) => ({activeStep: prevState.activeStep + 1}),
        () => {
          nextActionCallback(activeStep + 1);
        },
      );
    } else if (activeStep === step.length - 1) {
      nextActionCallback(activeStep + 1);
    }
  };

  nextAction = (nextProps) => {
    const {dispatch} = this.props;

    if (nextProps.nextActionWizard) {
      dispatch(setupActions.nextActionWizard(false));
      this.nextActionEvent();
    }
  };

  prevActionEvent = () => {
    const {backActionCallback} = this.props;
    const {activeStep} = this.state;

    if (activeStep === 0) {
      // last wizard step
      // last step
      backActionCallback(-1);
    } else if (activeStep > 0) {
      this.setState(
        (prevState) => ({activeStep: prevState.activeStep - 1}),
        () => {
          backActionCallback(activeStep - 1);
        },
      );
    }
  };

  prevAction = (nextProps) => {
    const {dispatch} = this.props;

    if (nextProps.prevActionWizard) {
      dispatch(setupActions.prevActionWizard(false));
      this.prevActionEvent();
    }
  };

  showActiveTitle = () => {
    const {step} = this.props;
    const {activeStep} = this.state;

    const newStep = step.slice();
    newStep[activeStep].title =
      newStep[activeStep].activeTitle === undefined ? newStep[activeStep].title : newStep[activeStep].activeTitle;

    return newStep;
  };

  showStep = () => {
    const {step} = this.props;
    const {activeStep} = this.state;

    return (
      <>
        <Stepper
          steps={this.showActiveTitle()}
          barStyle="solid"
          activeStep={activeStep}
          activeColor="#F7A246"
          activeTitleColor="#F7A246"
          completeTitleColor="#27AE60"
          completeColor="#27AE60"
          completeBarColor="#27AE60"
          defaultColor="#4F4F4F"
          titleFontSize={18}
          circleFontSize={20}
          // size="40px"
        />
        {step[activeStep].content}
      </>
    );
  };

  render() {
    return <>{this.showStep()}</>;
  }
}

Wizard.propTypes = {
  step: PropTypes.any,
  dispatch: PropTypes.func,
  backActionCallback: PropTypes.func,
  nextActionCallback: PropTypes.func,
};

Wizard.defaultProps = {
  step: null,
  dispatch: () => {},
  backActionCallback: () => {},
  nextActionCallback: () => {},
};

Wizard.Direction = {
  Next: Direction.Next,
  Previous: Direction.Previous,
};

Wizard.PubsubEvent = PubsubEvent;

export default Wizard;
